import { render, staticRenderFns } from "./customerCurrentAccount.vue?vue&type=template&id=c0c2be66&scoped=true"
import script from "./customerCurrentAccount.vue?vue&type=script&lang=js"
export * from "./customerCurrentAccount.vue?vue&type=script&lang=js"
import style0 from "./customerCurrentAccount.vue?vue&type=style&index=0&id=c0c2be66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c2be66",
  null
  
)

export default component.exports